import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
interface LazySectionProps {
  children: ReactNode;
  className?: string;
  threshold?: number;
  delay?: number;
}
export function LazySection({
  children,
  className = '',
  threshold = 0.1,
  delay = 0
}: LazySectionProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: threshold
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 30
  }} transition={{
    duration: 0.5,
    delay: delay / 1000,
    ease: [0.25, 0.1, 0.25, 1]
  }} className={`lazy-cv ${className}`} data-id="element-133">
      {children}
    </motion.div>;
}